export type DisplayPosterItem = {
  mediaType: "image" | "video";
  url: string;
};

/** รองรับ poster เก่าที่ยังไม่มี mediaType ใน DB แต่เป็นไฟล์วิดีโอ */
export function isVideoPoster(poster: DisplayPosterItem): boolean {
  if (poster.mediaType === "video") return true;
  return /\.(mp4|webm)(\?|#|$)/i.test(poster.url);
}

export function shouldUsePosterDurationTimer(
  poster: DisplayPosterItem,
  posterCount: number,
): boolean {
  if (posterCount <= 1) return false;
  return !isVideoPoster(poster);
}
